import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import { ArgoAttributeSchemaDefinitionTypeEnum } from '@redviking/argonaut-util/types/db-enums/argo/attribute_schema_definition_type';
import { EntityTypeMap, type ValidationResult } from '@redviking/argonaut-core-ui/types';
import {
    AttributeDefinition,
    type AttributeProperty,
} from './attribute.entity';

export function validateAttributeSelectAcl (): boolean {
    return validateAcls([ 'attribute_select' ]);
}

export function validateAttributeUpdateAcl (): boolean {
    return validateAcls([ 'attribute_update' ]);
}

function validateData (data: AttributeProperty, def: AttributeDefinition): ValidationResult {
    const dataType = def.type;
    const required = def.validationRequired;
    const min = def.validationMin;
    const max = def.validationMax;

    if (dataType === ArgoAttributeSchemaDefinitionTypeEnum.Text) {
        if (!data.str_val && required) {
            return {
                status: 'error',
                errorMessage: `Required Property: ${def.name}`,
            };
        }
        if (def.validationPattern) {
            const regexp = new RegExp(`${def.validationPattern}`, 'ug');
            if (!regexp.test(data.str_val || '')) {
                return {
                    status: 'error',
                    errorMessage: `Input for ${def.name} doesnt pass validation ${def.validationPattern}`,
                };
            }
        }
    } else if (dataType === ArgoAttributeSchemaDefinitionTypeEnum.Number) {
        const numVal = data.num_val;
        if (numVal === undefined && required) {
            return {
                status: 'error',
                errorMessage: `Required Property: ${def.name}`,
            };
        }
        if (min || max) {
            if (typeof numVal !== 'number') {
                return {
                    status: 'error',
                    errorMessage: 'Number validation requires a number',
                };
            }
            if (typeof min === 'number' && numVal < min) {
                return {
                    status: 'error',
                    errorMessage: `Input for ${def.name} is lower than minumum: ${min}`,
                };
            }
            if (typeof max === 'number' && numVal > max) {
                return {
                    status: 'error',
                    errorMessage: `Input for ${def.name} is higher than maximum: ${max}`,
                };
            }
        }
    }
    return {
        status: 'success',
    };
}

export function validateAttributeData (entityData: EntityTypeMap['attributeschema']): ValidationResult {
    if (entityData.schema.name.length === 0) {
        return {
            status: 'error',
            errorMessage: 'Schema Name is required',
        };
    }

    if (!entityData.schema.type) {
        return {
            status: 'error',
            errorMessage: 'Schema Type is required',
        };
    }

    const definitions = entityData.schema.definitions;
    for (let i = 0; i < definitions.length; i++) {
        const def = definitions[i];
        if (def.name.trim().length === 0) {
            return {
                status: 'error',
                errorMessage: `Attribute schema field definition #${i + 1} is missing a name`,
            };
        }
    }

    for (const attr of entityData.schema.attributes) {

        for (const reqDef of definitions.filter(d => d.validationRequired)) {
            if (!attr.attribute_data.find(ad => ad.attribute_schema_definition_id === reqDef.id)) {
                return {
                    status: 'error',
                    errorMessage: `Required Property: ${reqDef.name}`,
                };
            }
        }

        for (const ad of attr.attribute_data) {
            const definition = definitions.find(d => d.id === ad.attribute_schema_definition_id);

            // if a definition can't be found...
            if (!definition) {
                return {
                    status: 'error',
                    errorMessage: `Unknown Attribute definition for data on ${attr.name}`,
                };
            }
            const dataResult = validateData(ad, definition);
            if (dataResult.status !== 'success') {
                return dataResult;
            }
        }
    }

    return {
        status: 'success',
    };
}
